import React from 'react';
import { useCRM } from '../../utils/CRMContext';
import { useProjectPLWorkspace } from '../../hooks/useProjectPLWorkspace';
import ProjectPLDashboard from '../../pages/sales-activity/ProjectPLDashboard';
import '../../pages/ProjectPLPage.css';

const formatCurrencyShort = (value: number): string => {
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return `$${value.toLocaleString()}`;
};

const formatCurrencyFull = (value: number): string =>
  `$${value.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

const ProjectPLSection: React.FC = () => {
  const { pipelines } = useCRM();
  const workspace = useProjectPLWorkspace();

  if (!workspace.canAccess) {
    return (
      <div className="ppl-gate">
        <h2>Project P&amp;L access required</h2>
        <p>
          Project P&amp;L is available to admins and to employees with the{' '}
          <strong>Project Manager</strong> or <strong>Executive Assistant</strong> designation. If
          you need access, ask your admin to add one of those designations to your profile in
          Settings → Users.
        </p>
      </div>
    );
  }

  return (
    <ProjectPLDashboard
      embedded
      qbPayments={workspace.qbPayments}
      qbExpenses={workspace.qbExpenses}
      designFeePayments={workspace.designFeePayments}
      pipelines={pipelines}
      formatCurrency={formatCurrencyShort}
      formatCurrencyFull={formatCurrencyFull}
      syncing={workspace.syncing}
      syncResult={workspace.syncResult}
      lastSyncAt={workspace.lastSyncAt}
      onSync={workspace.triggerSync}
    />
  );
};

export default ProjectPLSection;
